export default __webpack_public_path__ + "static/media/zoom.3108d767.png";